import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Course } from "features/courses/types";
import { KeyDirection } from "features/creator/types";

interface CourseInitialStateType {
  showCourseTop: boolean;
  showCourseList: boolean;
  showWelcomePage: boolean;
  selectedCourse?: Course;
  selectedStage: number;
  selectedLevelByCourse: Partial<Record<Course, number>>;
  cursor: KeyDirection;
  action: { back: boolean; confirm: boolean };
}

const initialState: CourseInitialStateType = {
  showCourseTop: true,
  showCourseList: false,
  showWelcomePage: true,
  selectedCourse: null,
  selectedStage: 1,
  selectedLevelByCourse: {},
  cursor: KeyDirection.NONE,
  action: { back: false, confirm: false },
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    updateShowCourseTop(state, action: PayloadAction<boolean>) {
      state.showCourseTop = action.payload;
    },
    updateShowCourseList(state: CourseInitialStateType, action: PayloadAction<boolean>) {
      state.showCourseList = action.payload;
    },
    updateShowWelcomePage(state: CourseInitialStateType, action: PayloadAction<boolean>) {
      state.showWelcomePage = action.payload;
    },
    updateSelectedCourse(state: CourseInitialStateType, action: PayloadAction<{ course: Course }>) {
      state.selectedStage = 1;
      state.selectedLevelByCourse = {};
      state.selectedCourse = action.payload.course;
    },
    updateSelectedStage(state: CourseInitialStateType, action: PayloadAction<{ stage: number }>) {
      state.selectedStage = action.payload.stage;
    },
    updateSelectedLevel(
      state: CourseInitialStateType,
      action: PayloadAction<{ course: Course; level: number }>,
    ) {
      state.selectedLevelByCourse[action.payload.course] = action.payload.level;
    },
    updateCursor(state: CourseInitialStateType, action: PayloadAction<KeyDirection>) {
      state.cursor = action.payload;
    },
    updateAction(
      state: CourseInitialStateType,
      action: PayloadAction<{ back: boolean; confirm: boolean }>,
    ) {
      state.action = action.payload;
    },
  },
});
export const actions = { ...courseSlice.actions };
export default courseSlice.reducer;
